import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    label: {
        color: theme.colors.gray[7],
        fontFeatureSettings: `'clig' off, 'liga' off`,
        fontSize: rem(16),
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: rem(24),
    },

    buttonGroup: {
        display: "flex",
        gap: rem(24),
        flexJustify: "flex-start",
        flexAlign: "flex-start",
        flexDirection: "column",
        flexWrap: "nowrap",
    },
}))
